export default __webpack_public_path__ + "static/media/1913.6ba0d05d.png";